import regEx from 'universally-shared-code/util/regEx';

export default class Validator {
  static isNotEmpty(value) {
    return value != null && value !== '';
  }

  static isRegExValid(regEx) {
    try {
      new RegExp(regEx);
    } catch (err) {
      return false;
    }

    return true;
  }

  static isURLValid(url) {
    return url != null && url !== '' && url.match(regEx.url) !== null;
  }
}



// WEBPACK FOOTER //
// ./client/src/javascript/util/Validator.js